import { globalEnvConfig } from '@/global/config'
import { buildPreviewUrl, tryBuildPreviewUrl } from '@/tools/previewUrl'
import { Alert, Modal, ModalProps } from 'antd'

export type WaterMarkOption = {
  text: string
}
interface Props extends ModalProps {
  fileUrl: string
  waterMarkOption?: WaterMarkOption
}

export const DefaultWaterMarkOption: WaterMarkOption = {
  text: '咸亨SCP',
}
export interface PreviewModalOption {
  open: boolean
  fileUrl: string
}
export const DefaultPreviewOption: PreviewModalOption = {
  open: false,
  fileUrl: '',
}

export const convertUrl = (fileUrl: string) => {
  return buildPreviewUrl(globalEnvConfig.REACT_APP_PREVIEW_SERVER_URL, fileUrl)
}

export default function PreviewModal(props: Props) {
  const { fileUrl, waterMarkOption, ...restProps } = props
  const isModalShow = restProps.visible || restProps.open
  const previewResult = isModalShow
    ? tryBuildPreviewUrl(globalEnvConfig.REACT_APP_PREVIEW_SERVER_URL, fileUrl)
    : undefined
  return (
    <Modal
      {...restProps}
      title="文件预览"
      width={1200} // 宽度
      maskClosable={false} // 点击阴影是否关闭
      keyboard={false} // 是否支持esc
      destroyOnClose // 关闭时销毁 Modal 里的子元素
      bodyStyle={{ padding: '5px' }}
      centered
      cancelText="取消"
      okText={'确定'}
      getContainer={() => document.body}
      footer={false}
    >
      <div style={{ height: '80vh' }}>
        {previewResult?.success ? (
          <iframe
            src={`${previewResult.previewUrl}${
              waterMarkOption
                ? `&watermarkTxt= ${encodeURIComponent(waterMarkOption.text)}`
                : ''
            }`}
            title="预览"
            width="100%"
            height="100%"
          ></iframe>
        ) : previewResult ? (
          <Alert type="error" showIcon message={previewResult.message} />
        ) : null}
      </div>
    </Modal>
  )
}
import { globalEnvConfig } from '@/global/config'
import { buildPreviewUrl, tryBuildPreviewUrl } from '@/tools/previewUrl'
import { Alert, Modal, ModalProps } from 'antd'

export type WaterMarkOption = {
  text: string
}
interface Props extends ModalProps {
  fileUrl: string
  waterMarkOption?: WaterMarkOption
}

export const DefaultWaterMarkOption: WaterMarkOption = {
  text: '咸亨SCP',
}
export interface PreviewModalOption {
  open: boolean
  fileUrl: string
}
export const DefaultPreviewOption: PreviewModalOption = {
  open: false,
  fileUrl: '',
}

export const convertUrl = (fileUrl: string) => {
  return buildPreviewUrl(globalEnvConfig.REACT_APP_PREVIEW_SERVER_URL, fileUrl)
}

export default function PreviewModal(props: Props) {
  const { fileUrl, waterMarkOption, ...restProps } = props
  const isModalShow = restProps.visible || restProps.open
  const previewResult = isModalShow
    ? tryBuildPreviewUrl(globalEnvConfig.REACT_APP_PREVIEW_SERVER_URL, fileUrl)
    : undefined
  return (
    <Modal
      {...restProps}
      title="文件预览"
      width={1200} // 宽度
      maskClosable={false} // 点击阴影是否关闭
      keyboard={false} // 是否支持esc
      destroyOnClose // 关闭时销毁 Modal 里的子元素
      bodyStyle={{ padding: '5px' }}
      centered
      cancelText="取消"
      okText={'确定'}
      getContainer={() => document.body}
      footer={false}
    >
      <div style={{ height: '80vh' }}>
        {previewResult?.success ? (
          <iframe
            src={`${previewResult.previewUrl}${
              waterMarkOption
                ? `&watermarkTxt= ${encodeURIComponent(waterMarkOption.text)}`
                : ''
            }`}
            title="预览"
            width="100%"
            height="100%"
          ></iframe>
        ) : previewResult ? (
          <Alert type="error" showIcon message={previewResult.message} />
        ) : null}
      </div>
    </Modal>
  )
}
